/**
 * AboutCommercial.tsx — Gold Garage Door / About Us · Section 6/10
 * Cream · split copy + real commercial photo. MOBILE: real <style> media queries.
 * IMAGE: 92a74ae2->about-team-commercial-highlift.webp
 * 10WEB AI: keep <img> + <style>. Wave dividers intentional — keep.
 */

const COMM_IMG = "/wp-content/uploads/2026/06/about-team-commercial-highlift.webp";
const NAVY = "#081438";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const INK = "#1A1F2E";
const CREAM = "#FAF7F1";

/** check — DO NOT REPLACE WITH IMG */
const Check = () => <svg data-icon-container="lucide-do-not-replace" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={GOLD_DARK} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{
  flexShrink: 0,
  marginTop: "2px"
}}><polyline points="20 6 9 17 4 12" /></svg>;
const POINTS = [{
  h: "Homes",
  b: "Sectional, roller, tilt and panel doors — repairs, new installs, motors, springs and routine servicing."
}, {
  h: "Strata & real estate",
  b: "Fast, documented callouts for property managers across Sydney, with invoicing built for strata."
}, {
  h: "Commercial & industrial",
  b: "Heavy-duty roller shutters, high-lift tracks and warehouse doors kept compliant and moving."
}];
export default function AboutCommercial() {
  return <section id="about-commercial" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <style>{`
        .acom-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4rem; align-items: center; }
        @media (max-width: 880px) {
          .acom-grid { grid-template-columns: 1fr; gap: 2.5rem; }
          .acom-photo { order: -1; }
          .acom-photo img { height: 340px !important; }
          #about-commercial { padding-top: 3.5rem; padding-bottom: 3.5rem; }
        }
      `}</style>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.4,
      pointerEvents: "none",
      mixBlendMode: "multiply"
    }}><filter id="paper-ac"><feTurbulence type="fractalNoise" baseFrequency="0.04" numOctaves="5" stitchTiles="stitch" /><feColorMatrix type="matrix" values="0 0 0 0 0.85, 0 0 0 0 0.82, 0 0 0 0 0.74, 0 0 0 0.08 0" /></filter><rect width="100%" height="100%" filter="url(#paper-ac)" /></svg>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "4rem",
      left: "2rem",
      width: "60px",
      height: "60px",
      borderBottom: `2px solid ${GOLD}55`,
      borderLeft: `2px solid ${GOLD}55`,
      pointerEvents: "none",
      zIndex: 1
    }} />

      <div className="acom-grid" style={{
      maxWidth: "1150px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD_DARK,
          textTransform: "uppercase"
        }}>Who We Help</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.65rem, 6vw, 2.6rem)",
          color: NAVY,
          lineHeight: 1.15,
          margin: "0.75rem 0 1rem"
        }}>From a single garage to a whole warehouse</h2>
          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.02rem",
          color: INK,
          lineHeight: 1.75,
          marginBottom: "1.75rem"
        }}>Most of our work is residential — but the same crew that fixes a stuck roller in Cronulla also keeps Sydney businesses trading. One number for homes, strata and commercial sites alike.</p>

          <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "1.1rem",
          marginBottom: "2rem"
        }}>
            {POINTS.map((p, i) => <div key={i} style={{
            display: "flex",
            gap: "0.85rem",
            alignItems: "flex-start"
          }}>
                <Check />
                <div>
                  <div style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 700,
                fontSize: "1.02rem",
                color: NAVY
              }}>{p.h}</div>
                  <div style={{
                fontFamily: "'Manrope', sans-serif",
                fontSize: "0.95rem",
                color: INK,
                lineHeight: 1.6,
                marginTop: "0.15rem"
              }}>{p.b}</div>
                </div>
              </div>)}
          </div>

          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          padding: "0.875rem 1.75rem",
          background: `linear-gradient(135deg, ${GOLD}, #d4a017)`,
          color: NAVY,
          fontWeight: 700,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          borderRadius: "8px",
          textDecoration: "none",
          fontSize: "0.95rem",
          boxShadow: `0 4px 20px ${GOLD}35`
        }}>Talk to us about your site →</a>
        </div>

        <div className="acom-photo" style={{
        position: "relative"
      }}>
          <div aria-hidden style={{
          position: "absolute",
          top: "-12px",
          right: "-12px",
          width: "100%",
          height: "100%",
          border: `2px solid ${GOLD}45`,
          borderRadius: "16px",
          pointerEvents: "none"
        }} />
          <img src={COMM_IMG} alt="Gold Garage Door technician servicing a commercial high-lift roller door in Sydney" width={560} height={680} loading="lazy" decoding="async" style={{
          width: "100%",
          height: "480px",
          objectFit: "cover",
          borderRadius: "12px",
          display: "block",
          boxShadow: "0 18px 50px rgba(8,20,56,0.18)",
          position: "relative",
          zIndex: 1
        }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/9ada9b93-909d-463a-a8f5-c673b2a6de54.png" src="https://goldgaragedoor.com.au/wp-content/uploads/2026/05/9ada9b93-909d-463a-a8f5-c673b2a6de54.webp" />
          <div style={{
          position: "absolute",
          top: "1rem",
          right: "1rem",
          background: NAVY,
          border: `1px solid ${GOLD}50`,
          borderRadius: "999px",
          padding: "0.45rem 1rem",
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          zIndex: 2,
          boxShadow: "0 6px 24px rgba(0,0,0,0.4)"
        }}>
            <span style={{
            fontSize: "0.9rem"
          }}></span>
            <span style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: "0.8rem",
            fontWeight: 700,
            color: GOLD
          }}>Commercial high-lift</span>
          </div>
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}><path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill={NAVY} /></svg>
      </div>
    </section>;
}